import React from "react"

const TabbMark: React.FC = () => (
  <svg width="10" height="10" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.2911 16.5374L18.357 1.49284C18.2484 0.651586 17.5393 0 16.6794 0C16.5527 0 16.429 0.0152954 16.3113 0.0397682L3.86209 2.86025C2.4651 3.17533 1.39096 4.36532 1.23104 5.83368L0.012069 16.565C0.00603452 16.6292 0 16.6934 0 16.7607C0 17.7091 0.757332 18.4769 1.69268 18.4769H18.6135C19.5488 18.4769 20.3062 17.7091 20.3062 16.7607C20.3062 16.6843 20.3001 16.6109 20.2911 16.5374ZM10.1531 14.5337C7.66082 14.5337 5.63926 12.4841 5.63926 9.95733C5.63926 7.43053 7.66082 5.38094 10.1531 5.38094C12.6453 5.38094 14.6669 7.43053 14.6669 9.95733C14.6669 12.4841 12.6453 14.5337 10.1531 14.5337Z"
      fill="#171717"
    />
  </svg>
)

export default TabbMark
